import { AsyncPipe } from '@angular/common';
import { Component, OnDestroy } from '@angular/core';
import { CustomisableVariables } from '@shared/models/customisable-variables';
import { CustomisableVariablesService } from '@shared/services/customisable-variables.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'registration-error-page',
  templateUrl: './registration-error-page.component.html',
  styleUrls: ['./registration-error-page.component.scss'],
  standalone: true,
  imports: [AsyncPipe],
})
export class RegistrationErrorPageComponent implements OnDestroy {
  public customVariables$: Observable<CustomisableVariables> = this.customVariablesService.variables;
  private loginButton: HTMLElement;

  constructor(private customVariablesService: CustomisableVariablesService) {
    this.loginButton = document.getElementsByClassName('nav-login-button')[0] as HTMLElement;
    this.loginButton.style.display = 'none';
  }

  public ngOnDestroy() {
    this.loginButton.style.display = 'block';
  }
}
